// eslint-disable-next-line no-unused-vars
import React from "react"
/** @jsx jsx */
import { jsx } from "theme-ui"
import { colors } from "../../../utils/theme/colors"
import { fontWeights } from "../../../utils/theme/font-weights"
import Paragraph from "./paragraph"
import { Link } from "gatsby"

const Column = ({ title, content, url }) => {
  return (
    <div
      sx={{
        marginTop: [`2.5rem`, null, 0, null],
        order: [1, 1, 0, 0],
      }}
    >
      <Link
        to={url}
        sx={{
          textDecoration: `none`,
          width: ["100%", "100%", "60%", "60%"],
        }}
      >
        <h3
          sx={{
            color: colors.white,
            fontWeight: fontWeights.black,
            fontSize: `1.13rem`,
            lineHeight: 1.11,
            margin: 0,
          }}
        >
          {title}
        </h3>
      </Link>
      <div
        sx={{
          display: `flex`,
          flexDirection: `column`,
          marginTop: `1.87rem`,
        }}
      >
        {content.map((content, i) =>
          content.paragraph === `Careers` ? (
            <a
              key={i}
              sx={{
                textDecoration: `none`,
              }}
              href="https://www.linkedin.com/company/jellyfishglobal/jobs/"
              target="_blank"
              rel="noreferrer"
            >
              <Paragraph>{content.paragraph}</Paragraph>
            </a>
          ) : (
            <Paragraph key={i} url={content.url}>
              {content.paragraph}
            </Paragraph>
          )
        )}
      </div>
    </div>
  )
}

export default Column
